// init Slider
import {tns} from '/node_modules/tiny-slider/src/tiny-slider.js';

const slidermanager = {

    slider: function () {
        
        var slider = tns({
            container: '#stud-slider',
            items: 2,
            slideBy: 'page',
            autoplay: true,
            autoplayButton: false,
            controls: true,
            controlsContainer: false,
            autoplaySpeed: 2000,
            responsive: {
                640: {
                  items: 4
                },
                900: {
                    items: 6
                }
            }
        })

        // Fix a11y: div.tns-controls has aria-label which is prohibited on role="generic"
        var sliderContainer = document.getElementById('stud-slider');
        if (sliderContainer) {
            var controlsEl = sliderContainer.closest('.tns-outer')?.querySelector('.tns-controls');
            if (controlsEl) {
                controlsEl.setAttribute('role', 'group');
            }
        }

        var dotsContainer = document.querySelector('#slider .dots');

        slider.events.on('indexChanged', function (info) {
          updateActiveDot(info.displayIndex);
        });
        
        // Create and update active dots
        function updateActiveDot(index) {
          var slides = slider.getInfo().slideCount;
          var dots = dotsContainer.querySelectorAll('.dot');
        
          // Remove extra dots if any
          if (dots.length > slides) {
            for (var i = slides; i < dots.length; i++) {
              dots[i].remove();
            }
          }
          // Create additional dots if needed
          else if (dots.length < slides) {
            for (var i = dots.length; i < slides; i++) {
              var dot = document.createElement('span');
              dot.className = 'dot';
              dot.addEventListener('click', function () {
                slider.goTo(index);
              });
              dotsContainer.appendChild(dot);
            }
          }
        
          // Update active dot
          dots = dotsContainer.querySelectorAll('.dot');
          dots.forEach(function (dot, dotIndex) {
            dot.classList.toggle('active', dotIndex === index);
          });        
        }
        
        // Set initial active dot
        updateActiveDot(0);
  
        var sliderServices = tns({
            container: '.mob-services-grid',
            items: 1,
            slideBy: 'page',
            controls: false,
            rewind: true,
            nav: false,
            loop: true,
            clone: false, // Disable cloning
            autoplay: true,
            autoplayButton: false,
            responsive: {
                640: {
                  items: 2
                },
            }
        })
    }
}

export default slidermanager;
